import React from "react";
import { Box, Body2, Display5 } from "@sainsburys-tech/fable";

const display5Style = {
  fontSize: '22px',
  lineHeight: '26px',
  fontWeight: '800',
  fontFamily: 'MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif',
  color: '#404040',
  marginBottom: '25px',
};

const body2Style = {
  color: '#404040',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif'
};

const NoDataMessage = props => {
  return (
    <div className="fable:mt-2 fable:ml-1">
      {!props.title && <Body2 style={body2Style}>There are no items to display.</Body2>}

      {props.title && <Display5 style={display5Style}>{props.title}</Display5>}
      {props.subtitle && <Body2 style={body2Style}>{props.subtitle}</Body2>}
    </div>
  );
};

export default NoDataMessage;
